import axios from 'axios'

// URL base dell'API per le firme referendum, recuperato dall'env file

const FIRME_REFERENDUM_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'firme-referendum'

const headers = { 'Content-Type': 'application/json' }

class FirmeReferendumService {
    /**
     * Salva una firma di un referendum nel sistema.
     * Effettua una richiesta POST a `/firme-referendum/save` con i dati della firma.
     *
     * @param {Object} firma - Oggetto contenente i dettagli della firma da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    registraFirma(firma) {
        return axios.post(FIRME_REFERENDUM_REST_API_URL + "/save", firma, headers);
    }
    /**
     * Elimina una firma di un referendum nel sistema.
     * Effettua una richiesta POST a `/firme-referendum/delete` con i dati della firma.
     *
     * @param {Object} firma - Oggetto contenente i dettagli della firma da eliminare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    revocaFirma(firma) {
        return axios.post(FIRME_REFERENDUM_REST_API_URL + "/delete", firma, headers)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const firmeReferendumServiceInstance =new FirmeReferendumService()
export default firmeReferendumServiceInstance;